const API_BASE = process.env.REACT_APP_API_URL || 'https://manufacture-api.afsreman.com/api/v1';

async function fetchApi(endpoint, options = {}) {
  try {
    const response = await fetch(`${API_BASE}${endpoint}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Failed to fetch ${endpoint}:`, error);
    return null;
  }
}

// Banners (Hero Slides)
export async function getBanners() {
  const res = await fetchApi('/banners');
  return res?.data || [];
}

// Products
export async function getProducts(params = {}) {
  const query = new URLSearchParams(params).toString();
  const res = await fetchApi(`/products${query ? '?' + query : ''}`);
  return res?.data || [];
}

export async function getProductBySlug(slug) {
  const res = await fetchApi(`/products/${slug}`);
  return res;
}

export async function getProductsPaginated(params = {}) {
  const query = new URLSearchParams(params).toString();
  const res = await fetchApi(`/products${query ? '?' + query : ''}`);
  return res || { data: [], meta: {} };
}

// Services
export async function getServiceBySlug(slug) {
  const res = await fetchApi(`/services/${slug}`);
  return res;
}

export async function getServices() {
  const res = await fetchApi('/services');
  return res?.data || [];
}

// Clients
export async function getClients() {
  const res = await fetchApi('/clients');
  return res?.data || [];
}

// Company Settings
export async function getCompanySettings() {
  const res = await fetchApi('/company');
  return res?.data || {};
}

// Categories
export async function getCategories() {
  const res = await fetchApi('/categories');
  return res?.data || [];
}

// Brands
export async function getBrands() {
  const res = await fetchApi('/brands');
  return res?.data || [];
}

// Contact Form
export async function sendContactMessage(formData) {
  const res = await fetch(`${API_BASE}/contact`, {
    method: 'POST',
    body: formData, // FormData for file upload support
    headers: {
      'Accept': 'application/json',
    },
  });
  return await res.json();
}

// Part Quote Request
export async function sendPartQuoteRequest(data) {
  const res = await fetchApi('/public/part-quote-request', {
    method: 'POST',
    body: JSON.stringify(data),
  });
  return res;
}

// Part Unavailable Request
export async function sendPartUnavailableRequest(data) {
  const res = await fetchApi('/public/part-unavailable-request', {
    method: 'POST',
    body: JSON.stringify(data),
  });
  return res;
}



// Components
export async function getComponents(params = {}) {
  const query = new URLSearchParams(params).toString();
  const res = await fetchApi(`/components${query ? '?' + query : ''}`);
  return res || { data: [], meta: {} };
}

export async function getComponentCategories() {
  const res = await fetchApi('/components/categories');
  return res?.data || [];
}

export async function getComponentBrands() {
  const res = await fetchApi('/components/brands');
  return res?.data || [];
}

// Parts
export async function getParts(params = {}) {
  const query = new URLSearchParams(params).toString();
  const res = await fetchApi(`/parts${query ? '?' + query : ''}`);
  return res || { data: [], meta: {} };
}

export async function getPartCategories() {
  const res = await fetchApi('/parts/categories');
  return res?.data || [];
}

export async function getPartBrands() {
  const res = await fetchApi('/parts/brands');
  return res?.data || [];
}

export async function getPartMachineTypes() {
  const res = await fetchApi('/parts/machine-types');
  return res?.data || [];
}

// News / Blog
export async function getNews(params = {}) {
  const query = new URLSearchParams(params).toString();
  const res = await fetchApi(`/news${query ? '?' + query : ''}`);
  return res || { data: [], meta: {} };
}

export async function getNewsLatest() {
  const res = await fetchApi('/news/latest');
  return res?.data || [];
}

export async function getNewsDetail(slug) {
  const res = await fetchApi(`/news/${slug}`);
  return res?.data || null;
}
// About Page
export async function getAboutPage() {
  const res = await fetchApi('/about');
  return res?.data || {};
}

// Gallery
export async function getGallery() {
  const res = await fetchApi('/gallery');
  return res?.data || [];
}

// Careers
export async function getCareers() {
  const res = await fetchApi('/careers');
  return res?.data || [];
}

export async function getCareerDetail(slug) {
  const res = await fetchApi(`/careers/${slug}`);
  return res?.data || null;
}

export default {
  getBanners,
  getProducts,
  getServices,
  getClients,
  getCompanySettings,
  getCategories,
  getBrands,
  sendContactMessage,
  sendPartQuoteRequest,
  sendPartUnavailableRequest,
  getAboutPage,
  getGallery,
  getNews,
  getNewsLatest,
  getNewsDetail,
  getParts,
  getPartCategories,
  getPartBrands,
  getPartMachineTypes,
  getComponents,
  getComponentCategories,
  getComponentBrands,
  getCareers,
  getCareerDetail,
};